import { motion } from "framer-motion";
import { Gem, Sparkles, Truck, MessageCircle, Heart, ShieldCheck } from "lucide-react";
import { SITE } from "@/data/site";

const ICONS = { Gem, Sparkles, Truck, MessageCircle, Heart, ShieldCheck };

export const WhyNovaLand = () => {
  return (
    <section id="neden" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="eyebrow">Değerlerimiz</span>
          <h2 className="font-display text-4xl lg:text-5xl mt-3 text-[hsl(var(--nl-anthracite))]">
            Neden <em className="not-italic font-serif italic gold-text">NovaLand</em>?
          </h2>
          <div className="gold-line mt-5 mx-auto" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {SITE.features.map((f, i) => {
            const Icon = ICONS[f.icon] || Gem;
            return (
              <motion.div
                key={i}
                data-testid={`feature-${i}`}
                initial={{ opacity: 0, y: 28 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, delay: 0.05 * i }}
                className="group relative p-8 lg:p-10 border border-[hsl(var(--nl-line))] hover:border-[hsl(var(--nl-champagne))] bg-[hsl(var(--nl-cream))] transition-all duration-500"
              >
                <div className="w-12 h-12 grid place-items-center border border-[hsl(var(--nl-champagne)/0.5)] gold-text group-hover:bg-[hsl(var(--nl-champagne)/0.1)] transition-colors">
                  <Icon size={20} strokeWidth={1.5} />
                </div>
                <h3 className="font-display text-2xl mt-6 text-[hsl(var(--nl-anthracite))]">{f.title}</h3>
                <p className="text-sm text-[hsl(var(--muted-foreground))] mt-3 leading-relaxed">{f.text}</p>
                <div className="absolute top-0 right-0 font-serif italic text-[5rem] leading-none gold-text opacity-[0.08] pr-6 pt-2 pointer-events-none">
                  {i + 1}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyNovaLand;
